<template>
  <div class="addExtendAss">
    <el-form :model="dataForm" :rules="rules" ref="dataForm">
      <div class="basebox">
        <div class="baseic">基础信息</div>
        <el-row :gutter="0" style="text-align: center">
          <!-- 选择用户 -->
          <el-col :span="6">
            <el-form-item prop="commUserDTO.userCode">
              <div class="link-type link-type2" @click="selectUserClick">
                选择用户
              </div>
              <el-input v-model="dataForm.commUserDTO.userCode" disabled placeholder="请选择用户"></el-input>
            </el-form-item>
          </el-col>
          <!--员工号-->
          <el-col :span="6">
            <el-form-item label="姓名" prop="commUserDTO.userName">
              <el-input v-model="dataForm.commUserDTO.userName" disabled placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <!-- 中文姓名 -->
          <el-col :span="6">
            <el-form-item label="主职所属网点" prop="commUserDTO.orgId">
              <el-select v-model="dataForm.commUserDTO.orgId" disabled :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in companyresults" :key="index" :label="item.name" :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 邮件 -->
          <el-col :span="6">
            <el-form-item label="主要职位" prop="commUserDTO.jobCode">
              <el-select v-model="dataForm.commUserDTO.jobCode" disabled :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in historyPositionlist" :key="index" :label="item.positionName"
                  :value="item.positionCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0" style="text-align: center">
          <el-col :span="6">
            <el-form-item label="兼职1所属网点" prop="commUserDTO.partTimeOutletOne">
              <el-select v-model="dataForm.commUserDTO.partTimeOutletOne" disabled :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in partResults0" :key="index" :label="item.name" :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--员工号-->
          <el-col :span="6">
            <el-form-item label="兼职职位1" prop="commUserDTO.partTimeJobcodeOne">
              <el-select v-model="dataForm.commUserDTO.partTimeJobcodeOne" disabled :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in parttimejobList0" :key="index" :label="item.positionName"
                  :value="item.positionCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 中文姓名 -->
          <el-col :span="6">
            <el-form-item label="兼职2所属网点" prop="commUserDTO.partTimeOutletTwo">
              <el-select v-model="dataForm.commUserDTO.partTimeOutletTwo" disabled :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in partResults1" :key="index" :label="item.name" :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 邮件 -->
          <el-col :span="6">
            <el-form-item label="兼职职位2" prop="commUserDTO.partTimeJobcodeTwo">
              <el-select v-model="dataForm.commUserDTO.partTimeJobcodeTwo" disabled :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in parttimejobList1" :key="index" :label="item.positionName"
                  :value="item.positionCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0" style="text-align: center">
          <!--员工号-->
          <el-col :span="6">
            <el-form-item label="在职状态" prop="commUserDTO.jobStatus">
              <el-select v-model="dataForm.commUserDTO.jobStatus" disabled :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in jobStatusArr" :key="index" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="basebox">
        <div class="baseic">考核期延长信息</div>
        <el-row :gutter="0" style="text-align: center">
          <!-- 选择用户 -->
          <el-col :span="6">
            <el-form-item prop="trainingCategory" label="考核类型">
              <el-select v-model="dataForm.trainingCategory" disabled :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in trainTypeArrs" :key="index" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--员工号-->
          <el-col :span="6">
            <el-form-item label="经销商品牌" prop="brandCode">
              <el-select v-model="dataForm.brandCode" :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in certBrandArrs" :key="index" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 中文姓名 -->
          <el-col :span="6">
            <el-form-item label="项目分类" prop="jobCategory">
              <el-select v-model="dataForm.jobCategory" :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in jobTypeArrs" :key="index" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 邮件 -->
          <el-col :span="6">
            <el-form-item label="认证名称" prop="courseName">
              <el-select v-model="dataForm.courseName" filterable remote placeholder="请输入认证名称"
                :remote-method="courseNameFun" :loading="courseNameLoading" @change="courseNameChange">
                <el-option v-for="item in courseNameArr" :key="item.key" :label="item.certName" :value="item.certId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0" style="text-align: center">
          <el-col :span="6">
            <el-form-item label="认证编号" prop="courseCode">
              <el-input v-model="dataForm.courseCode" disabled placeholder="请输入认证编号"></el-input>
            </el-form-item>
          </el-col>
          <!--员工号-->
          <el-col :span="6">
            <el-form-item label="考核方式" prop="assessmentType">
              <el-select v-model="dataForm.assessmentType" :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in assMethodArr" :key="index" :label="item.name" :value="item.type">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 中文姓名 -->
          <el-col :span="6">
            <el-form-item label="延长到期日" prop="delayedDay">
              <el-tooltip content="" placement="bottom" effect="light">
                <div slot="content">
                  关键基础岗认证要求到期日<br />
                  1.优先按照单独设置的延长到期日计算；<br />
                  2.如未单独设置延长到期日，则按照统一延长到期日计算；<br />
                  3.如未设置延长到期日，则按照政策龄计算的要求到期日计算。
                </div>
                <img src="@/assets/img/course/icon-question-fill.png" alt="" />
              </el-tooltip>
              <el-date-picker v-model="dataForm.delayedDay" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 邮件 -->
          <el-col :span="6">
            <el-form-item label="是否有效" prop="validFlag">
              <el-tooltip content="设为有效，则该用户单独设置的延长到期日生效，计入报告计算逻辑，
  设为无效，则该用户单独设置的延长到期日不生效，不计入报表计算逻辑" placement="bottom" effect="light">
                <img src="@/assets/img/course/icon-question-fill.png" alt="" />
              </el-tooltip>
              <el-select v-model="dataForm.validFlag" :placeholder="$t('cert.select')">
                <el-option v-for="(item, index) in validArr" :key="index" :label="item.name" :value="item.type">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0" style="text-align: center">
          <!--员工号-->
          <el-col :span="24">
            <el-form-item label="操作备注" prop="remark" style="width: 100% !important;">
              <el-input v-model="dataForm.remark" type="textarea" :rows="4" show-word-limit maxlength="1000"
                placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="display: flex;justify-content: flex-end;align-items: center;">
          <el-button type="primary" :disabled="btnloading" @click="saveData">保存</el-button>
          <el-button @click="colsePage">关闭</el-button>
        </div>
      </div>
    </el-form>
    <!-- 用户选择页面 -->
    <el-dialog :title="$t('trainer.userInformation')" :visible="isShowUser" width="95%" :before-close="selectUserClose">
      <UserItem-tree ref="userSelete" :showOrg="1" v-on:useronOk="useronOk"></UserItem-tree>
    </el-dialog>
  </div>
</template>

<script>
import UserItem from '@/components/rm/user-select/index'
export default {
  components: {
    'UserItem-tree': UserItem,
  },
  data() {
    let _this = this;
    return {
      courseNameLoading: false,
      isShowUser: false,
      courseNameArr: [],
      // 项目分类
      jobTypeArrs: _this.enums['acheBaseJob'].filter((item) => {
        return item.code.slice(0, 2) == 10
      }),
      // 品牌
      certBrandArrs: _this.enums["brandCode"],
      // 考核类型
      trainTypeArrs: _this.enums['acheBaseTrain'],
      // 职位回显
      jobStatusArr: _this.enums['jobStatus'],
      assMethodArr: [
        {
          name: "年度考核",
          type: 'Y',
        },
        {
          name: "季度考核",
          type: 'Q',
        },
      ],
      validArr: [
        {
          name: "有效",
          type: 1,
        },
        {
          name: "无效",
          type: 0,
        },
      ],
      dataForm: {
        userId: null,
        curYear: new Date().getFullYear(),
        remark: "",
        validFlag: 1,
        delayedDay: "",
        assessmentType: "",
        courseCode: "",
        courseName: "",
        jobCategoryName: "",
        jobCategory: '',
        brandCode: "",
        trainingCategoryName: "",
        trainingCategory: '10',
        commUserDTO: {},
      },
      btnloading: false,
      companyresults: [],
      historyPositionlist: [],
      partResults0: [],
      partResults1: [],
      parttimejobList0: [],
      parttimejobList1: [],
      rules: {
        trainingCategory: [{ required: true, message: '请选择', trigger: 'change' }],
        brandCode: [{ required: true, message: '请选择', trigger: 'change' }],
        jobCategory: [{ required: true, message: '请选择', trigger: 'change' }],
        courseName: [{ required: true, message: '请选择', trigger: 'change' }],
        courseCode: [{ required: true, message: '请选择', trigger: 'change' }],
        assessmentType: [{ required: true, message: '请选择', trigger: 'change' }],
        delayedDay: [{ required: true, message: '请选择', trigger: 'change' }],
        validFlag: [{ required: true, message: '请选择', trigger: 'change' }],
        remark: [{ required: true, message: '请输入', trigger: 'blur' }],
      }
    };
  },
  methods: {
    selectPositionByCode(positionCode, index) {
      console.log(positionCode, index)
      this.$request.get(`/sys/commuser/selectPositionByCode`,
        {
          positionCode: positionCode
        }).then((res) => {
          this['parttimejobList' + index] = res
        }).catch((err) => {
          console.log(err)
        })
    },
    selectOrgByParam(partTimeOutletOne, orgType, index) {
      console.log(partTimeOutletOne, orgType, index)
      this.$request.get('/sys/org/selectOrgByParam',
        {
          orgId: partTimeOutletOne,
          orgType: orgType
        }
      ).then((res) => {
        this['partResults' + index] = res
      }).catch((err) => {
        console.log(err)
      })
    },
    getOrgUserData(jobCode) {
      this.$request.get('/sys/commuser/selectCurrentAndHistoryPositionByCode',
        {
          positionCode: jobCode
        }).then((res) => {
          this.historyPositionlist = res
        }).catch((err) => {
          console.log(err)
        })
    },
    getOrgData(orgId, orgType) {
      this.$request.get('/sys/org/queryOrgForUserViewAndEdit',
        {
          orgId: orgId,
          orgType: orgType
        }
      ).then((res) => {
        // 经销商时需要回显品牌
        if (this.dataForm.orgType === '60') {
          this.companyresults = res
        } else {
          this.companyresults = res
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 选择用户选择弹出页面事件
    selectUserClick() {
      console.log('123123')
      this.isShowUser = true
      if (this.$refs.userSelete) {
        this.$refs.userSelete.resetQueryData()
      }
    },
    // 选择用户选择关闭页面事件
    selectUserClose() {
      this.isShowUser = false
    },
    // 选择用户选择确定带回数据事件
    useronOk(data) {
      this.getOrgData(data.orgId, data.orgType)
      this.getOrgUserData(data.jobCode)
      this.selectOrgByParam(data.partTimeOutletOne, data.orgType, 0)
      this.selectOrgByParam(data.partTimeOutletTwo, data.orgType, 1)
      this.selectPositionByCode(data.partTimeOutletOne, 0)
      this.selectPositionByCode(data.partTimeOutletOne, 1)
      setTimeout(() => {
        this.dataForm.commUserDTO = data;
        this.dataForm.userId = data.userCode;
        this.isShowUser = false;
      }, 300);
    },
    courseNameFun(val) {
      this.courseNameLoading = true;
      this.$request.get('/learning/achieveKeyCertSetting/certInfoList', { seachText: val }).then((res) => {
        console.log(res)
        this.courseNameLoading = false;
        this.courseNameArr = res
      })
    },
    courseNameChange(data) {
      console.log(data)
      var obj = {};
      //使用find()方法在下拉数据中根据value绑定的数据查找对象。
      obj = this.courseNameArr.find(function (item) {
        return item.certId === data;
      })
      this.dataForm.courseCode = obj.certCode
      console.log(obj);
    },
    saveData() {
      console.log(this.dataForm)
      if (!this.dataForm.userId) {
        this.$message.warning('请选择用户')
        return
      } else {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.btnloading = true;
            this.$request.post('/learning/achieveKeyCertSetting/infoListAssessmentSetting/add', this.dataForm).then((res) => {
              console.log(res)
              this.colsePage()
              this.btnloading = false;
            })
          } else {
            return false;
          }
        });
      }

      // this.$request.post('/learning/achieveKeyCertSetting/infoListAssessmentSetting/add', this.dataForm).then((res) => {
      //     console.log(res)
      //     this.colsePage()
      // })
    },
    colsePage() {
      this.tabRemove(this.$store.state.contentTabsActiveName)
    },
    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: 'report-achieve-assessment-extendAssessment'
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.basebox {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
}

.baseic {
  background-color: rgb(204, 204, 204);
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  font-weight: bold;
  margin-bottom: 14px;
}

.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}

.link-type2 {
  position: relative;
  padding-left: 8px;

  &::before {
    content: "*";
    position: absolute;
    left: 0;
    top: 2px;
    color: #f56c6c;
  }
}

.el-form-item {
  margin-bottom: 16px !important;
}
</style>
